module.exports = __webpack_public_path__ + "media/images/icons/facebook-cac67e5aa69c1c048f96098d7892415a.svg";